module.exports = "/_next/static/files/16d137724a037197c25b42c6a19a22d7.svg";